/* RESPONSIBLE TEAM: team-app-security */
export const ADMIN_EVENT_TYPES = [
  {
    // this isn't a real admin event type
    value: 'AppAdminEvents::All',
    text: 'admins.app-admin-events-constants.all',
  },
  {
    value: 'AppAdminEvents::AdminDeletion',
    text: 'admins.app-admin-events-constants.admin-deletion',
  },
  {
    value: 'AppAdminEvents::AdminDeprovisioned',
    text: 'admins.app-admin-events-constants.admin-deprovisioned',
  },
  {
    value: 'AppAdminEvents::AdminImpersonationEnd',
    text: 'admins.app-admin-events-constants.admin-impersonation-end',
  },
  {
    value: 'AppAdminEvents::AdminImpersonationStart',
    text: 'admins.app-admin-events-constants.admin-impersonation-start',
  },
  {
    value: 'AppAdminEvents::AdminImpersonationConsentApproved',
    text: 'admins.app-admin-events-constants.admin-impersonation-consent-approved',
  },
  {
    value: 'AppAdminEvents::AdminImpersonationConsentRevoked',
    text: 'admins.app-admin-events-constants.admin-impersonation-consent-revoked',
  },
  {
    value: 'AppAdminEvents::OauthTokenRevocation',
    text: 'admins.app-admin-events-constants.oauth-token-revocation',
  },
  {
    value: 'AppAdminEvents::AdminInviteChange',
    text: 'admins.app-admin-events-constants.admin-invite-change',
  },
  {
    value: 'AppAdminEvents::AdminInviteCreation',
    text: 'admins.app-admin-events-constants.admin-invite-creation',
  },
  {
    value: 'AppAdminEvents::AdminBulkInviteCreation',
    text: 'admins.app-admin-events-constants.admin-bulk-invite-creation',
  },
  {
    value: 'AppAdminEvents::AdminInviteDeletion',
    text: 'admins.app-admin-events-constants.admin-invite-deletion',
  },
  {
    value: 'AppAdminEvents::AdminLoginFailure',
    text: 'admins.app-admin-events-constants.admin-login-failure',
  },
  {
    value: 'AppAdminEvents::AdminLoginSuccess',
    text: 'admins.app-admin-events-constants.admin-login-success',
  },
  {
    value: 'AppAdminEvents::AdminLoginAttemptsReset',
    text: 'admins.app-admin-events-constants.admin-login-attempts-reset',
  },
  {
    value: 'AppAdminEvents::AdminTwoFactorLoginFailure',
    text: 'admins.app-admin-events-constants.admin-two-factor-login-failure',
  },
  {
    value: 'AppAdminEvents::AdminLogout',
    text: 'admins.app-admin-events-constants.admin-logout',
  },
  {
    value: 'AppAdminEvents::AdminPermissionChange',
    text: 'admins.app-admin-events-constants.admin-permission-change',
  },
  {
    value: 'AppAdminEvents::RoleCreation',
    text: 'admins.app-admin-events-constants.role-creation',
  },
  {
    value: 'AppAdminEvents::RoleChange',
    text: 'admins.app-admin-events-constants.role-change',
  },
  {
    value: 'AppAdminEvents::RoleDeletion',
    text: 'admins.app-admin-events-constants.role-deletion',
  },
  {
    value: 'AppAdminEvents::SeatChange',
    text: 'admins.app-admin-events-constants.seat-change',
  },
  {
    value: 'AppAdminEvents::InboxAccessChange',
    text: 'admins.app-admin-events-constants.inbox-access-change',
  },
  {
    value: 'AppAdminEvents::AppNameChange',
    text: 'admins.app-admin-events-constants.app-name-change',
  },
  {
    value: 'AppAdminEvents::AdminAwayModeChange',
    text: 'admins.app-admin-events-constants.admin-away-mode-change',
  },
  {
    value: 'AppAdminEvents::AppTimezoneChange',
    text: 'admins.app-admin-events-constants.app-timezone-change',
  },
  {
    value: 'AppAdminEvents::BulkExport',
    text: 'admins.app-admin-events-constants.bulk-export',
  },
  {
    value: 'AppAdminEvents::MessageDeletion',
    text: 'admins.app-admin-events-constants.message-deletion',
  },
  {
    value: 'AppAdminEvents::RulesetActivation',
    text: 'admins.app-admin-events-constants.ruleset-activation',
  },
  {
    value: 'AppAdminEvents::RulesetCreation',
    text: 'admins.app-admin-events-constants.ruleset-creation',
  },
  {
    value: 'AppAdminEvents::RulesetDeletion',
    text: 'admins.app-admin-events-constants.ruleset-deletion',
  },
  {
    value: 'AppAdminEvents::WorkflowCreation',
    text: 'admins.app-admin-events-constants.workflow-creation',
  },
  {
    value: 'AppAdminEvents::WorkflowDeletion',
    text: 'admins.app-admin-events-constants.workflow-deletion',
  },
  {
    value: 'AppAdminEvents::WorkflowUpdate',
    text: 'admins.app-admin-events-constants.workflow-update',
  },
  {
    value: 'AppAdminEvents::WorkflowStatusChange',
    text: 'admins.app-admin-events-constants.workflow-live-status-change',
  },
  {
    value: 'AppAdminEvents::MessageStateChange',
    text: 'admins.app-admin-events-constants.message-state-change',
  },
  {
    value: 'AppAdminEvents::CampaignDeletion',
    text: 'admins.app-admin-events-constants.campaign-deletion',
  },
  {
    value: 'AppAdminEvents::AppAdminJoin',
    text: 'admins.app-admin-events-constants.app-admin-join',
  },
  {
    value: 'AppAdminEvents::AdminProvisioned',
    text: 'admins.app-admin-events-constants.admin-provisioned',
  },
  {
    value: 'AppAdminEvents::AppAuthenticationMethodChange',
    text: 'admins.app-admin-events-constants.app-authentication-method-change',
  },
  {
    value: 'AppAdminEvents::AppDataDeletion',
    text: 'admins.app-admin-events-constants.app-data-deletion',
  },
  {
    value: 'AppAdminEvents::AppIdentityVerificationChange',
    text: 'admins.app-admin-events-constants.app-identity-verification-change',
  },
  {
    value: 'AppAdminEvents::AppOutboundAddressChange',
    text: 'admins.app-admin-events-constants.app-outbound-address-change',
  },
  {
    value: 'AppAdminEvents::AppPackageTokenRegeneration',
    text: 'admins.app-admin-events-constants.app-package-token-regeneration',
  },
  {
    value: 'AppAdminEvents::AppWebhookCreation',
    text: 'admins.app-admin-events-constants.app-webhook-creation',
  },
  {
    value: 'AppAdminEvents::AppWebhookDeletion',
    text: 'admins.app-admin-events-constants.app-webhook-deletion',
  },
  {
    value: 'AppAdminEvents::AppGoogleSsoDomainChange',
    text: 'admins.app-admin-events-constants.app-google-sso-domain-change',
  },
  {
    value: 'AppAdminEvents::CampaignStateChange',
    text: 'admins.app-admin-events-constants.campaign-state-change',
  },
  {
    value: 'AppAdminEvents::AppTeamMembershipModification',
    text: 'admins.app-admin-events-constants.app-team-membership-modification',
  },
  {
    value: 'AppAdminEvents::AppTeamCreation',
    text: 'admins.app-admin-events-constants.app-team-creation',
  },
  {
    value: 'AppAdminEvents::AppTeamDeletion',
    text: 'admins.app-admin-events-constants.app-team-deletion',
  },
  {
    value: 'AppAdminEvents::TeamAssignmentLimitChange',
    text: 'admins.app-admin-events-constants.team-assignment-limit-change',
  },
  {
    value: 'AppAdminEvents::AppPackageInstallation',
    text: 'admins.app-admin-events-constants.app-package-installation',
  },
  {
    value: 'AppAdminEvents::AppPackageUninstallation',
    text: 'admins.app-admin-events-constants.app-package-uninstallation',
  },
  {
    value: 'AppAdminEvents::AppDataExport',
    text: 'admins.app-admin-events-constants.app-data-export',
  },
  {
    value: 'AppAdminEvents::HelpCenterSettingsChange',
    text: 'admins.app-admin-events-constants.help-center-settings-change',
  },
  {
    value: 'AppAdminEvents::OfficeHoursChange',
    text: 'admins.app-admin-events-constants.office-hours-change',
  },
  {
    value: 'AppAdminEvents::ConversationTopicCreation',
    text: 'admins.app-admin-events-constants.conversation-topic-creation',
  },
  {
    value: 'AppAdminEvents::ConversationTopicChange',
    text: 'admins.app-admin-events-constants.conversation-topic-change',
  },
  {
    value: 'AppAdminEvents::ConversationTopicDeletion',
    text: 'admins.app-admin-events-constants.conversation-topic-deletion',
  },
  {
    value: 'AppAdminEvents::ConversationPartDeletion',
    text: 'admins.app-admin-events-constants.conversation-part-deletion',
  },
  {
    value: 'AppAdminEvents::InboundConversationsChange',
    text: 'admins.app-admin-events-constants.inbound-conversations-change',
  },
  {
    value: 'AppAdminEvents::WelcomeMessageChange',
    text: 'admins.app-admin-events-constants.welcome-message-change',
  },
  {
    value: 'AppAdminEvents::PrivacyPolicyNoticeChange',
    text: 'admins.app-admin-events-constants.privacy-policy-notice-change',
  },
  {
    value: 'AppAdminEvents::PrivacyPolicyNoticeContentsChange',
    text: 'admins.app-admin-events-constants.privacy-policy-notice-contents-change',
  },
  {
    value: 'AppAdminEvents::MessengerLookAndFeelChange',
    text: 'admins.app-admin-events-constants.messenger-look-and-feel-change',
  },
  {
    value: 'AppAdminEvents::BrandSettingsChange',
    text: 'admins.app-admin-events-constants.brand-settings-change',
  },
  {
    value: 'AppAdminEvents::SearchBrowseEnabledChange',
    text: 'admins.app-admin-events-constants.search-browse-enabled-change',
  },
  {
    value: 'AppAdminEvents::ArticlesInMessengerEnabledChange',
    text: 'admins.app-admin-events-constants.articles-in-messenger-enabled-change',
  },
  {
    value: 'AppAdminEvents::SearchBrowseRequiredChange',
    text: 'admins.app-admin-events-constants.search-browse-required-change',
  },
  {
    value: 'AppAdminEvents::MessengerSearchRequiredChange',
    text: 'admins.app-admin-events-constants.messenger-search-required-change',
  },
  {
    value: 'AppAdminEvents::UpfrontEmailCollectionChange',
    text: 'admins.app-admin-events-constants.upfront-email-collection-change',
  },
  {
    value: 'AppAdminEvents::TemporaryExpectationChange',
    text: 'admins.app-admin-events-constants.temporary-expectation-change',
  },
  {
    value: 'AppAdminEvents::TemporaryExpectationMessagesChange',
    text: 'admins.app-admin-events-constants.temporary-expectation-messages-change',
  },
  {
    value: 'AppAdminEvents::SecuritySettingsChange',
    text: 'admins.app-admin-events-constants.security-settings-change',
  },
  {
    value: 'AppAdminEvents::MaliciousDomainsSettingChange',
    text: 'admins.app-admin-events-constants.malicious-domains-setting-change',
  },
  {
    value: 'AppAdminEvents::TrustedDomainsSettingChange',
    text: 'admins.app-admin-events-constants.trusted-domains-setting-change',
  },
  {
    value: 'AppAdminEvents::AdminTwoFactorAuthChange',
    text: 'admins.app-admin-events-constants.admin-two-factor-auth-change',
  },
  {
    value: 'AppAdminEvents::MessengerSpacesChange',
    text: 'admins.app-admin-events-constants.messenger-spaces-change',
  },
  {
    value: 'AppAdminEvents::ArticleCreation',
    text: 'admins.app-admin-events-constants.article-creation',
  },
  {
    value: 'AppAdminEvents::ArticleDeletion',
    text: 'admins.app-admin-events-constants.article-deletion',
  },
  {
    value: 'AppAdminEvents::ArticleContentCreation',
    text: 'admins.app-admin-events-constants.article-content-creation',
  },
  {
    value: 'AppAdminEvents::ArticleContentUpdate',
    text: 'admins.app-admin-events-constants.article-content-update',
  },
  {
    value: 'AppAdminEvents::ArticleContentDeletion',
    text: 'admins.app-admin-events-constants.article-content-deletion',
  },
  {
    value: 'AppAdminEvents::ArticleContentPublished',
    text: 'admins.app-admin-events-constants.article-content-published',
  },
  {
    value: 'AppAdminEvents::ArticleContentUnpublished',
    text: 'admins.app-admin-events-constants.article-content-unpublished',
  },
  {
    value: 'AppAdminEvents::EmailSignatureChange',
    text: 'admins.app-admin-events-constants.email-signature-change',
  },
  {
    value: 'AppAdminEvents::BulkDataExportCreation',
    text: 'admins.app-admin-events-constants.bulk-data-export-creation',
  },
  {
    value: 'AppAdminEvents::BulkDataExportRun',
    text: 'admins.app-admin-events-constants.bulk-data-export-run',
  },
  {
    value: 'AppAdminEvents::RecoveryCodeSent',
    text: 'admins.app-admin-events-constants.recovery-code-sent',
  },
  {
    value: 'AppAdminEvents::BillingAddresseesChange',
    text: 'admins.app-admin-events-constants.billing-addressees-change',
  },
  {
    value: 'AppAdminEvents::BillingAddresseesBouncedAndRemoved',
    text: 'admins.app-admin-events-constants.bounced-email-address',
  },
  {
    value: 'AppAdminEvents::AdminUnauthorizedSignInMethod',
    text: 'admins.app-admin-events-constants.admin-unauthorized-sign-in-method',
  },
  {
    value: 'AppAdminEvents::AdminPasswordResetRequest',
    text: 'admins.app-admin-events-constants.admin-password-reset-request',
  },
  {
    value: 'AppAdminEvents::AdminPasswordResetSuccess',
    text: 'admins.app-admin-events-constants.admin-password-reset-success',
  },
  {
    value: 'AppAdminEvents::BulkDelete',
    text: 'admins.app-admin-events-constants.bulk-delete',
  },
  {
    value: 'AppAdminEvents::AdminAssignmentLimitChange',
    text: 'admins.app-admin-events-constants.admin-assignment-limit-change',
  },
  {
    value: 'AppAdminEvents::AdminConversationAssignmentLimitChange',
    text: 'admins.app-admin-events-constants.admin-conversation-assignment-limit-change',
  },
  {
    value: 'AppAdminEvents::AdminTicketAssignmentLimitChange',
    text: 'admins.app-admin-events-constants.admin-ticket-assignment-limit-change',
  },
  {
    value: 'AppAdminEvents::FinOptIn',
    text: 'admins.app-admin-events-constants.fin-opt-in',
  },
  {
    value: 'AppAdminEvents::AppIdentityVerificationReminderDisabled',
    text: 'admins.app-admin-events-constants.idv-reminder-disabled',
  },
  {
    value: 'AppAdminEvents::MessengerPlatformAvailabilityChange',
    text: 'admins.app-admin-events-constants.messenger-platform-availability-change',
  },
  {
    value: 'AppAdminEvents::MessengerPlatformInactivityDisableEvent',
    text: 'admins.app-admin-events-constants.messenger-platform-inactivity-disable-event',
  },
  {
    value: 'AppAdminEvents::IpAllowlistSettingChange',
    text: 'admins.app-admin-events-constants.ip-allowlist-setting-change',
  },
  {
    value: 'AppAdminEvents::AdminMobileLoginFailure',
    text: 'admins.app-admin-events-constants.admin-mobile-login-failure',
  },
  {
    value: 'AppAdminEvents::AdminMobileLoginSuccess',
    text: 'admins.app-admin-events-constants.admin-mobile-login-success',
  },
  {
    value: 'AppAdminEvents::AdminNameChange',
    text: 'admins.app-admin-events-constants.admin-name-change',
  },
  {
    value: 'AppAdminEvents::AdminPasswordChange',
    text: 'admins.app-admin-events-constants.admin-password-change',
  },
  {
    value: 'AppAdminEvents::AdminEmailChange',
    text: 'admins.app-admin-events-constants.admin-email-change',
  },
  {
    value: 'AppAdminEvents::CustomReportCreate',
    text: 'admins.app-admin-events-constants.report-create',
  },
  {
    value: 'AppAdminEvents::CustomReportUpdate',
    text: 'admins.app-admin-events-constants.report-update',
  },
  {
    value: 'AppAdminEvents::CustomReportDelete',
    text: 'admins.app-admin-events-constants.report-delete',
  },
  {
    value: 'AppAdminEvents::ReportingFolderCreate',
    text: 'admins.app-admin-events-constants.reporting-folder-create',
  },
  {
    value: 'AppAdminEvents::ReportingFolderDelete',
    text: 'admins.app-admin-events-constants.reporting-folder-delete',
  },
  {
    value: 'AppAdminEvents::ReportingFolderNameChange',
    text: 'admins.app-admin-events-constants.reporting-folder-name-change',
  },
  {
    value: 'AppAdminEvents::ReportScheduledShareCreate',
    text: 'admins.app-admin-events-constants.report-scheduled-share-create',
  },
  {
    value: 'AppAdminEvents::ReportScheduledShareUpdate',
    text: 'admins.app-admin-events-constants.report-scheduled-share-update',
  },
  {
    value: 'AppAdminEvents::ReportScheduledShareDelete',
    text: 'admins.app-admin-events-constants.report-scheduled-share-delete',
  },
  {
    value: 'AppAdminEvents::ReportSnapshotCreate',
    text: 'admins.app-admin-events-constants.report-snapshot-create',
  },
  {
    value: 'AppAdminEvents::ReportingFolderPositionChange',
    text: 'admins.app-admin-events-constants.reporting-folder-position-change',
  },
  {
    value: 'AppAdminEvents::ReportingFolderReportsChange',
    text: 'admins.app-admin-events-constants.reporting-folder-reports-change',
  },
  {
    value: 'AppAdminEvents::ReportingFolderPinChange',
    text: 'admins.app-admin-events-constants.reporting-folder-pin-change',
  },
  {
    value: 'AppAdminEvents::ReportingCsvExport',
    text: 'admins.app-admin-events-constants.reporting-csv-export',
  },
  {
    value: 'AppAdminEvents::ReportAccessCreate',
    text: 'admins.app-admin-events-constants.report-access-create',
  },
  {
    value: 'AppAdminEvents::ReportAccessDelete',
    text: 'admins.app-admin-events-constants.report-access-delete',
  },
  {
    value: 'AppAdminEvents::ReportAccessUpdate',
    text: 'admins.app-admin-events-constants.report-access-update',
  },
  {
    value: 'AppAdminEvents::SeatRevoke',
    text: 'admins.app-admin-events-constants.seat-revoke',
  },
  {
    value: 'AppAdminEvents::AdminChannelChange',
    text: 'admins.app-admin-events-constants.admin-channel-change',
  },
  {
    value: 'AppAdminEvents::StandaloneChannelChange',
    text: 'admins.app-admin-events-constants.standalone-channel-change',
  },
  {
    value: 'AppAdminEvents::FinPersistedDataContextAttributeChange',
    text: 'admins.app-admin-events-constants.fin-persisted-data-context-attribute-change',
  },
  {
    value: 'AppAdminEvents::AiAgentCustomizationSettingsChange',
    text: 'admins.app-admin-events-constants.ai-agent-customization-settings-change',
  },
  {
    value: 'AppAdminEvents::AiAgentIdentitySettingsChange',
    text: 'admins.app-admin-events-constants.ai-agent-identity-settings-change',
  },
  {
    value: 'AppAdminEvents::AiAgentMultilingualSettingsChange',
    text: 'admins.app-admin-events-constants.ai-agent-multilingual-settings-change',
  },
  {
    value: 'AppAdminEvents::AiAgentGuidanceChange',
    text: 'admins.app-admin-events-constants.ai-agent-guidance-change',
  },
  {
    value: 'AppAdminEvents::AiAgentFinPlaygroundChange',
    text: 'admins.app-admin-events-constants.ai-agent-fin-playground-change',
  },
  {
    value: 'AppAdminEvents::AiAgentPreviewTokenGenerated',
    text: 'admins.app-admin-events-constants.ai-agent-preview-token-generated',
  },
  {
    value: 'AppAdminEvents::MessengerLanguageChange',
    text: 'admins.app-admin-events-constants.messenger-language-change',
  },
  {
    value: 'AppAdminEvents::BrandCreation',
    text: 'admins.app-admin-events-constants.brand-creation',
  },
  {
    value: 'AppAdminEvents::BrandUpdate',
    text: 'admins.app-admin-events-constants.brand-update',
  },
  {
    value: 'AppAdminEvents::BrandDeletion',
    text: 'admins.app-admin-events-constants.brand-deletion',
  },
  {
    value: 'AppAdminEvents::SeriesCreation',
    text: 'admins.app-admin-events-constants.series-creation',
  },
  {
    value: 'AppAdminEvents::SeriesUpdate',
    text: 'admins.app-admin-events-constants.series-update',
  },
  {
    value: 'AppAdminEvents::SeriesSettingsUpdate',
    text: 'admins.app-admin-events-constants.series-settings-update',
  },
  {
    value: 'AppAdminEvents::SeriesDeletion',
    text: 'admins.app-admin-events-constants.series-deletion',
  },
  {
    value: 'AppAdminEvents::SeriesStatusChange',
    text: 'admins.app-admin-events-constants.series-status-change',
  },
  {
    value: 'AppAdminEvents::ActionRiskAcceptedChange',
    text: 'admins.app-admin-events-constants.action-risk-accepted-change',
  },
  {
    value: 'AppAdminEvents::ActionPublished',
    text: 'admins.app-admin-events-constants.action-published',
  },
  {
    value: 'AppAdminEvents::ActionStatusChange',
    text: 'admins.app-admin-events-constants.action-status-change',
  },
  {
    value: 'AppAdminEvents::ActionUpdate',
    text: 'admins.app-admin-events-constants.action-update',
  },
  {
    value: 'AppAdminEvents::SelectionSetCreation',
    text: 'admins.app-admin-events-constants.selection-set-creation',
  },
  {
    value: 'AppAdminEvents::SelectionSetArchive',
    text: 'admins.app-admin-events-constants.selection-set-archive',
  },
  {
    value: 'AppAdminEvents::MessengerLaunchToConversationChange',
    text: 'admins.app-admin-events-constants.messenger-launch-to-conversation-change',
  },
  {
    value: 'AppAdminEvents::AliasModeChange',
    text: 'admins.app-admin-events-constants.alias_mode_change',
  },
  {
    value: 'AppAdminEvents::HippaComplianceSettingsChange',
    text: 'admins.app-admin-events-constants.hippa-compliance-settings-change',
  },
  {
    value: 'AppAdminEvents::AiInboxTranslationSettingChange',
    text: 'admins.app-admin-events-constants.ai-inbox-translation-settings-change',
  },
  {
    value: 'AppAdminEvents::EmailSettingsChange',
    text: 'admins.app-admin-events-constants.email-settings-change',
  },
  {
    value: 'AppAdminEvents::StripInboundEmailLinksChange',
    text: 'admins.app-admin-events-constants.strip-inbound-email-links-change',
  },
  {
    value: 'AppAdminEvents::ContentSuggestionsChange',
    text: 'admins.app-admin-events-constants.content-suggestions-change',
  },
  {
    value: 'AppAdminEvents::DeveloperHubSecretRevealed',
    text: 'admins.app-admin-events-constants.developer-hub-secret-revealed',
  },
  {
    value: 'AppAdminEvents::DeveloperHubSecretCopied',
    text: 'admins.app-admin-events-constants.developer-hub-secret-copied',
  },
  {
    value: 'AppAdminEvents::CustomEmojiDeletion',
    text: 'admins.app-admin-events-constants.custom-emoji-deletion',
  },
  {
    value: 'AppAdminEvents::AttachUploadsInlineSettingChange',
    text: 'admins.app-admin-events-constants.attach-uploads-inline-setting-change',
  },
  {
    value: 'AppAdminEvents::UserCameraAttachmentsSettingChange',
    text: 'admins.app-admin-events-constants.user-camera-attachments-setting-change',
  },
  {
    value: 'AppAdminEvents::UserMediaAttachmentsSettingChange',
    text: 'admins.app-admin-events-constants.user-media-attachments-setting-change',
  },
  {
    value: 'AppAdminEvents::UserFileAttachmentsSettingChange',
    text: 'admins.app-admin-events-constants.user-file-attachments-setting-change',
  },
  {
    value: 'AppAdminEvents::UserGifsSettingChange',
    text: 'admins.app-admin-events-constants.user-gifs-setting-change',
  },
  {
    value: 'AppAdminEvents::UserVoiceNotesSettingChange',
    text: 'admins.app-admin-events-constants.user-voice-notes-setting-change',
  },
  {
    value: 'AppAdminEvents::UserConversationAttachmentsSettingChange',
    text: 'admins.app-admin-events-constants.user-conversation-attachments-setting-change',
  },
  {
    value: 'AppAdminEvents::TeammateGifsSettingChange',
    text: 'admins.app-admin-events-constants.teammate-gifs-setting-change',
  },
  {
    value: 'AppAdminEvents::AllowedAttachmentFiletypesSettingChange',
    text: 'admins.app-admin-events-constants.allowed-attachment-filetypes-setting-change',
  },
  {
    value: 'AppAdminEvents::ScimGroupCreation',
    text: 'admins.app-admin-events-constants.scim-group-creation',
  },
  {
    value: 'AppAdminEvents::ScimGroupUpdate',
    text: 'admins.app-admin-events-constants.scim-group-update',
  },
  {
    value: 'AppAdminEvents::ScimGroupDeletion',
    text: 'admins.app-admin-events-constants.scim-group-deletion',
  },
  {
    value: 'AppAdminEvents::ScimAdminProfileUpdate',
    text: 'admins.app-admin-events-constants.scim-admin-profile-update',
  },
  {
    value: 'AppAdminEvents::ScimAdminPasswordUpdate',
    text: 'admins.app-admin-events-constants.scim-admin-password-update',
  },
  {
    value: 'AppAdminEvents::ScimSystemEnabled',
    text: 'admins.app-admin-events-constants.scim-system-enabled',
  },
  {
    value: 'AppAdminEvents::ScimSystemDisabled',
    text: 'admins.app-admin-events-constants.scim-system-disabled',
  },
  {
    value: 'AppAdminEvents::ScimSettingsChange',
    text: 'admins.app-admin-events-constants.scim-settings-change',
  },
  {
    value: 'AppAdminEvents::ScimGroupMembershipChange',
    text: 'admins.app-admin-events-constants.scim-group-membership-change',
  },
  {
    value: 'AppAdminEvents::ScimAdminRoleChange',
    text: 'admins.app-admin-events-constants.scim-admin-role-change',
  },
  {
    value: 'AppAdminEvents::ScimGroupsBulkUpdate',
    text: 'admins.app-admin-events-constants.scim-groups-bulk-update',
  },
  {
    value: 'AppAdminEvents::ScimAdminBulkRoleAssignment',
    text: 'admins.app-admin-events-constants.scim-admin-bulk-role-assignment',
  },
  {
    value: 'AppAdminEvents::MacroCreation',
    text: 'admins.app-admin-events-constants.macro-creation',
  },
  {
    value: 'AppAdminEvents::MacroUpdate',
    text: 'admins.app-admin-events-constants.macro-update',
  },
  {
    value: 'AppAdminEvents::MacroDeletion',
    text: 'admins.app-admin-events-constants.macro-deletion',
  },
  {
    value: 'AppAdminEvents::McpServerCreated',
    text: 'admins.app-admin-events-constants.mcp-server-created',
  },
  {
    value: 'AppAdminEvents::McpServerUpdated',
    text: 'admins.app-admin-events-constants.mcp-server-updated',
  },
  {
    value: 'AppAdminEvents::McpServerDeleted',
    text: 'admins.app-admin-events-constants.mcp-server-deleted',
  },
  {
    value: 'AppAdminEvents::McpServerEnabled',
    text: 'admins.app-admin-events-constants.mcp-server-enabled',
  },
  {
    value: 'AppAdminEvents::McpServerDisabled',
    text: 'admins.app-admin-events-constants.mcp-server-disabled',
  },
  {
    value: 'AppAdminEvents::McpServerOauthConnected',
    text: 'admins.app-admin-events-constants.mcp-server-oauth-connected',
  },
  {
    value: 'AppAdminEvents::McpServerOauthDisconnected',
    text: 'admins.app-admin-events-constants.mcp-server-oauth-disconnected',
  },
  {
    value: 'AppAdminEvents::McpActionAdded',
    text: 'admins.app-admin-events-constants.mcp-action-added',
  },
  {
    value: 'AppAdminEvents::McpActionsBatchAdded',
    text: 'admins.app-admin-events-constants.mcp-actions-batch-added',
  },
  {
    value: 'AppAdminEvents::McpActionUpdated',
    text: 'admins.app-admin-events-constants.mcp-action-updated',
  },
  {
    value: 'AppAdminEvents::McpActionRemoved',
    text: 'admins.app-admin-events-constants.mcp-action-removed',
  },
  {
    value: 'AppAdminEvents::AiCategoryChange',
    text: 'admins.app-admin-events-constants.ai-category-change',
  },
  {
    value: 'AppAdminEvents::EscalationRuleChange',
    text: 'admins.app-admin-events-constants.escalation-rule-change',
  },
  {
    value: 'AppAdminEvents::StartConversationButtonTextChange',
    text: 'admins.app-admin-events-constants.start-conversation-button-text-change',
  },
  {
    value: 'AppAdminEvents::CustomAuthenticationTokenCreation',
    text: 'admins.app-admin-events-constants.custom-authentication-token-creation',
  },
  {
    value: 'AppAdminEvents::MessengerApiSecretCreation',
    text: 'admins.app-admin-events-constants.messenger-api-secret-creation',
  },
  {
    value: 'AppAdminEvents::MessengerApiSecretDeletion',
    text: 'admins.app-admin-events-constants.messenger-api-secret-deletion',
  },
  {
    value: 'AppAdminEvents::WorkspaceDeletionRequest',
    text: 'admins.app-admin-events-constants.workspace-deletion-request',
  },
  {
    value: 'AppAdminEvents::UnassignUnsnoozedAtCapacitySettingChange',
    text: 'admins.app-admin-events-constants.unassign-unsnoozed-at-capacity-setting-change',
  },
  {
    value: 'AppAdminEvents::AutomaticAwayModeSettingChange',
    text: 'admins.app-admin-events-constants.automatic-away-mode-setting-change',
  },
  {
    value: 'AppAdminEvents::FinAgentApiSettingsChange',
    text: 'admins.app-admin-events-constants.fin-agent-api-settings-change',
  },
  {
    value: 'AppAdminEvents::QaMonitorCreation',
    text: 'admins.app-admin-events-constants.qa-monitor-creation',
  },
  {
    value: 'AppAdminEvents::QaMonitorUpdate',
    text: 'admins.app-admin-events-constants.qa-monitor-update',
  },
  {
    value: 'AppAdminEvents::QaMonitorArchive',
    text: 'admins.app-admin-events-constants.qa-monitor-archive',
  },
  {
    value: 'AppAdminEvents::QaScorecardCreation',
    text: 'admins.app-admin-events-constants.qa-scorecard-creation',
  },
  {
    value: 'AppAdminEvents::QaScorecardUpdate',
    text: 'admins.app-admin-events-constants.qa-scorecard-update',
  },
  {
    value: 'AppAdminEvents::QaScorecardArchive',
    text: 'admins.app-admin-events-constants.qa-scorecard-archive',
  },
  {
    value: 'AppAdminEvents::LeadToUserMerge',
    text: 'admins.app-admin-events-constants.lead-to-user-merge',
  },
  {
    value: 'AppAdminEvents::ShopifyRefundOrder',
    text: 'admins.app-admin-events-constants.shopify-refund-order',
  },
  {
    value: 'AppAdminEvents::ShopifyReplacementOrder',
    text: 'admins.app-admin-events-constants.shopify-replacement-order',
  },
  {
    value: 'AppAdminEvents::ShopifyGiftCardCompensation',
    text: 'admins.app-admin-events-constants.shopify-gift-card-compensation',
  },
  {
    value: 'AppAdminEvents::ShopifyAddReplacementItem',
    text: 'admins.app-admin-events-constants.shopify-add-replacement-item',
  },
  {
    value: 'AppAdminEvents::CsvImportCreation',
    text: 'admins.app-admin-events-constants.csv-import-creation',
  },
  {
    value: 'AppAdminEvents::CsvImportCompletion',
    text: 'admins.app-admin-events-constants.csv-import-completion',
  },
];
